import { supabase } from '@/integrations/supabase/client';

/**
 * SEC-H1 — read whether a server capability is ACTIVE for a shop (public.shop_capability_active: entitled AND
 * platform-enabled AND, for add-ons, switched on).
 *
 * This is a UX hint only. The database is the authority (e.g. trigger zzz_automatic_dispatch_entitlement_guard
 * refuses a browser-created automatic dispatch whatever the browser believes). So the answer is three-valued:
 *   true  — the server says active;
 *   false — the server says NOT active: skip the path and offer the manual alternative up front;
 *   null  — unknown (error, older backend): attempt nothing special; the server will refuse if it must.
 */
export async function readServerCapabilityActive(shopId: string, capability: string): Promise<boolean | null> {
  try {
    const { data, error } = await supabase.rpc(
      'shop_capability_active' as never,
      { p_shop_id: shopId, p_capability: capability } as never,
    );
    if (error) return null;
    if (data === true) return true;
    if (data === false) return false;
    return null;
  } catch {
    return null;
  }
}
